import { toast } from "react-toastify";

import I18n from "Services/i18n";
import SubscriptionsService from "Services/subscriptions";
import { SUBSCRIPTIONS_PAGINATION } from "../Constants/subscriptions";

export const LOAD_SUBSCRIPTIONS_FILTERS_REQUESTED =
  "LOAD_SUBSCRIPTIONS_FILTERS_REQUESTED";
export const LOAD_SUBSCRIPTIONS_FILTERS_OK = "LOAD_SUBSCRIPTIONS_FILTERS_OK";
export const LOAD_SUBSCRIPTIONS_FILTERS_FAIL =
  "LOAD_SUBSCRIPTIONS_FILTERS_FAIL";

export const LOAD_SUBSCRIPTIONS_REQUESTED = "LOAD_SUBSCRIPTIONS_REQUESTED";
export const LOAD_SUBSCRIPTIONS_OK = "LOAD_SUBSCRIPTIONS_OK";
export const LOAD_SUBSCRIPTIONS_FAIL = "LOAD_SUBSCRIPTIONS_FAIL";

export const LOAD_SUBSCRIPTIONS_COUNT_REQUESTED =
  "LOAD_SUBSCRIPTIONS_COUNT_REQUESTED";
export const LOAD_SUBSCRIPTIONS_COUNT_OK = "LOAD_SUBSCRIPTIONS_COUNT_OK";
export const LOAD_SUBSCRIPTIONS_COUNT_FAIL = "LOAD_SUBSCRIPTIONS_COUNT_FAIL";

export const CHANGE_FILTERS = "CHANGE_FILTERS";

export const EDIT_AUDIENCES_REQUEST = "EDIT_AUDIENCES_REQUEST";
export const EDIT_AUDIENCES_OK = "EDIT_AUDIENCES_OK";
export const EDIT_AUDIENCES_FAIL = "EDIT_AUDIENCES_FAIL";

export function loadSubscriptionsFilters(filters = "") {
  return (dispatch) => {
    dispatch({ type: LOAD_SUBSCRIPTIONS_FILTERS_REQUESTED });
    SubscriptionsService.loadSubscriptionsFilters(filters)
      .then((data) => {
        dispatch({
          type: LOAD_SUBSCRIPTIONS_FILTERS_OK,
          data,
        });
      })
      .catch((errors) => {
        dispatch({
          type: LOAD_SUBSCRIPTIONS_FILTERS_FAIL,
          errors,
        });
      });
  };
}

export function loadSubscriptions(
  limit = SUBSCRIPTIONS_PAGINATION.PAGES_LIMIT,
  offset = 0,
  filters = ""
) {
  return (dispatch) => {
    dispatch({ type: LOAD_SUBSCRIPTIONS_REQUESTED });
    SubscriptionsService.loadSubscriptions(limit, offset, filters)
      .then((data) => {
        dispatch({
          type: LOAD_SUBSCRIPTIONS_OK,
          data,
        });
      })
      .catch((errors) => {
        if (errors && errors.status && errors.status === 408) {
          toast.warn(I18n.getStringByKey("toast_warn-load-subscriptions"));
        }

        dispatch({
          type: LOAD_SUBSCRIPTIONS_FAIL,
          errors,
        });
      });
  };
}

export function audienceEdit(body) {
  return (dispatch) => {
    dispatch({ type: EDIT_AUDIENCES_REQUEST });
    SubscriptionsService.audiencesEdit(body)
      .then((data) => {
        dispatch(loadSubscriptionsFilters());
        dispatch(loadSubscriptions());
        dispatch({
          type: EDIT_AUDIENCES_OK,
          data,
        });
        toast.success("Audiences successfully changed");
      })
      .catch((errors) => {
        if (errors && errors.status && errors.status === 408) {
          toast.warn("Audiences changed failed");
        }

        dispatch({
          type: EDIT_AUDIENCES_FAIL,
          errors,
        });
      });
  };
}

export function loadSubscriptionsCount(filters = "") {
  return (dispatch) => {
    dispatch({ type: LOAD_SUBSCRIPTIONS_COUNT_REQUESTED });
    SubscriptionsService.loadSubscriptionsCount(filters)
      .then((data) => {
        dispatch({
          type: LOAD_SUBSCRIPTIONS_COUNT_OK,
          data,
        });
      })
      .catch((errors) => {
        dispatch({
          type: LOAD_SUBSCRIPTIONS_COUNT_FAIL,
          errors,
        });
      });
  };
}

export function changeFilters(preparedFilters) {
  return (dispatch) => {
    dispatch({ type: CHANGE_FILTERS, preparedFilters });
  };
}

export function changeFiltersOrders(preparedFilters, orders) {
  for (let i = 0; i < orders?.length; i++) {
    const order = orders[i];
    for (let j = 0; j < preparedFilters?.length; j++) {
      if (preparedFilters[j].type === order.id) {
        preparedFilters[j].order = order.desc ? "desc" : "asc";
      } else {
        preparedFilters[j].order = "none";
      }
    }
  }

  let newArr = [...preparedFilters];

  return (dispatch) => {
    dispatch({ type: CHANGE_FILTERS, preparedFilters: newArr });
  };
}
